import { useUser } from 'hooks/useUser';
import { Navigate, Outlet } from 'react-router-dom';

export function ProtectedRoute() {
  const { user } = useUser();
  const isAuthenticated = user && user.emailVerified;

  if (isAuthenticated) {
    return <Outlet />;
  }

  return <Navigate to="/auth" replace />;
}
